export const getRenderer =
  (valueDecorator: (value: string | number) => string) =>
  (icon: React.ReactNode) =>
  (value: string | number): React.ReactElement => (
    <span className="flex flex-row gap-1 items-center text-muted-foreground">
      {icon}
      {valueDecorator(value)}
    </span>
  );
